import { ErrorMessageQuery, QueryError } from './types';

export const getQueryError = (result: { error?: unknown }): ErrorMessageQuery | undefined => {
    if (result.error) {
        const error = result.error as QueryError;
        return {
            message: error.data.message,
            status: Number.isNaN(Number(error.status)) ? 400 : Number(error.status),
        };
    }
};
